import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { TableContainer, Paper, Typography, Box } from "@mui/material";
import { api, get, post } from "../../../../utils/api";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../Components/Masters/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import { companyId } from "../../../../utils/companyId";
import Add from "./Add";

import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import Cards from "../../../../Components/Common/Cards";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import { getMonthName } from "../../../../utils/getMonthName";
// import MonthYearFilter from "../../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import TopMenuUpload from "../../../../Components/Masters/TopMenuUpload";
import { truncateNumber } from "../../../../utils/common";
import Scope4Layout from "../../../../Layout/Scope4Layout";
import View from "../InHouseOffset/InHouse/View";
import FugitiveBulkUpload from "../../../Scope1/FugitiveEmmissions/FugitiveBulkUpload";
// import BulkUpload from "../NaturalGas/BulkUpload";

const Offset = () => {
  // const [selectedDate, setSelectedDate] = useState({});
  const [cardData, setCardData] = useState(null);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    // "Month of energy export": false,
    Vendor: false,
    "Project Type": false,
  });
  const columnWidth = "12% 20% 20% 18% 22% 8%";
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  // const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    projectType: [],
    vendorRegistry: [],
  });
  // const [quantityRange, setQuantityRange] = useState({ min: "", max: "" });
  // const [hoursRange, setHoursRange] = useState({ min: "", max: "" });
  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);

  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);

  const [bulkUploadTable, setBulkUploadTable] = useState(true);

  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [matchData, setMatchData] = useState([]);

  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    startMonth: null,
    endMonth: null,
    projectType: [],
    vendorRegistry: [],
  });

  // const [equipmentDetails, setEquipmentDetails] = useState({});
  // const [formData, setFormData] = useState({});

  let bannerData = [
    {
      title: "Total Credits Purchased",
      description: truncateNumber(cardData?.total),
      // unit: cardData?.total?.unit,
    },
    {
      title: "Top Project Type By No. of credits purchased",
      description:
        cardData?.topProjectTypes?.length > 0
          ? cardData?.topProjectTypes.map((el) => el.projectType)
          : "N/A",
    },
    {
      title: "Energy export Month",
      description: truncateNumber(cardData?.monthly?.totalCreditsPurchased),
      // unit: cardData?.monthly?.unit || "",
      filter: "date",
      defaultValue: {},
    },
  ];

  const fetchExcelData = async () => {
    await get("/scope4/off-set-credit-purchase/exportExcel")
      .then((res) => {
        let data = res?.data?.data;
        let arr = [];
        data &&
          data.forEach((el, idx) => {
            // options.forEach((op) => {
              arr.push({
                "S No.": arr.length + 1,
                "Month (in 01/25 or Jan-25)": "",
                Vendor: "",
                "Project ID/ Name": "",
                "Project Type": el?.projectType,
                "No. of credits purchased (tCO2e)": "",
                "Vintage Year": "",
                "Applied to which scope(s) / emission source(s)": "",
              // });
            });
          });
        setExcelData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const fetchCardData = useCallback(async () => {
    try {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth(); // Current month (0-based, January = 0)
      const response = await get(
        `scope4/off-set-credit-purchase/cardData?year=${
          selectedYear ? selectedYear : currentYear
        }&month=${selectedMonth ? selectedMonth : currentMonth + 1}`
      );
      setCardData(response.data);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  }, [selectedMonth, selectedYear]);

  useEffect(() => {
    fetchCardData();
  }, [selectedMonth, selectedYear]);

  const handlePeriodChange = (key, value, filterType) => {
    const [year, month] = value.split("-");
    setSelectedMonth(month);
    setSelectedYear(year);
    fetchCardData(year, month, "");
  };

  const filters = ["Date", "Project Type", "Vendor"];
  const options = useMemo(() => [
    "Scope 1",
    "Scope 2",
    "Scope 3 - Category 1",
    "Scope 3 - Category 3",
    "Scope 3 - Category 5",
    "Scope 3 - Category 6",
    "Scope 3 - Category 7",
    "Scope 3 - Category 9",
  ], []);
  const inputData = useMemo(() => ([
    // {
    //   fieldName: "consumptionPeriod",
    //   title: "Month of energy export",
    //   type: "date",
    // },
    {
      fieldName: "vendorRegistry",
      title: "Vendor",
      type: "select",
      options: [
        "Verra (VCS)",
        "Gold Standard",
        "Climate Action Reserve (CAR)",
        "American Carbon Registry (ACR)",
        "Plan Vivo",
        "CDM (Clean Development Mechanism)",
        "Puro.Earth",
        "ART-TREES (Architecture for REDD+ Transactions)",
        "BioCarbon Registry",
        "India GHG Program",
        "Nori",
        "South Pole",
        "ClimeCo",
        "CarbonClear",
        "Others",
      ],
    },
    {
      fieldName: "projectIdOrName",
      title: "Project ID/ Name",
      type: "text",
    },
    {
      fieldName: "projectType",
      title: "Project Type",
      type: "select",
      options: [
        "REDD+ (Forestry / Avoided Deforestation)",
        "Afforestation / Reforestation",
        "Solar Energy Projects",
        "Wind Energy Projects",
        "Hydropower Projects",
        "Biogas / Biomethane Projects",
        "Landfill Gas Recovery",
        "Energy Efficiency (Industrial or Residential)",
        "Cookstove Distribution Projects",
        "Waste-to-Energy",
        "Biochar Production",
        "Direct Air Capture (DAC)",
        "Soil Carbon Sequestration",
        "Blue Carbon (Mangroves, Seagrass)",
        "Carbon Mineralization / Enhanced Weathering",
        "Carbon Capture and Storage (CCS)",
        "Agricultural Methane Reduction",
        "Others",
      ],
    },
    {
      fieldName: "creditsPurchased",
      title: "No. of credits purchased (tCO₂e)",
      type: "number",
    },
    {
      fieldName: "vintageYear",
      title: "Vintage Year",
      type: "number",
    },
    {
      fieldName: "appliedScopes",
      title: "Applied to which scope(s) / emission source(s)",
      type: "select",
      options: options,
    },
    {
      fieldName: "remarks",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ]), [options]);

  // Merge static options with newly added unique values for dropdowns
  const computedInputData = useMemo(() => {
    return inputData.map((field) => {
      if (field.fieldName === "vendorRegistry") {
        const merged = Array.from(
          new Set([...(field.options || []), ...(uniqueValues.vendorRegistry || [])])
        );
        return { ...field, options: merged };
      }
      if (field.fieldName === "projectType") {
        const merged = Array.from(
          new Set([
            ...(field.options || []),
            ...(uniqueValues.projectType || []),
          ])
        );
        return { ...field, options: merged };
      }
      return field;
    });
  }, [uniqueValues, inputData]);

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`scope4/off-set-credit-purchase/get`);
      const data = response.data.data;
      const uniqueProjectType = [
        ...new Set(
          data.map((el) => el.projectType).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueVendor = [
        ...new Set(
          data.map((el) => el.vendorRegistry).filter(Boolean) // Filter out undefined values
        ),
      ];

      return {
        projectType: uniqueProjectType,
        vendorRegistry: uniqueVendor,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  // useEffect(()=>{
  //   fetchCardData();
  // })

 

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {},
    pageNumber = page
  ) => {
    fetchCardData(selectedMonth, selectedMonth);
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page:pageNumber ? pageNumber : page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        company: companyId,
        createdBy: companyId,
      }).toString();
      const response = await get(
        `/scope4/off-set-credit-purchase/get?${queryParams}`
      );
      setData(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const updatePage = () => {
    if (page > 1 && data.length === 1) {
      setPage(page - 1);
    }
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

 
  // Applying selected filters
  const handleApplyFilters = () => {
    setPage(1);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setSelectedFields({
      projectType: tempFilter?.projectType || [],
      vendorRegistry: tempFilter?.vendorRegistry || [],
    });
    setStartMonth(tempFilter?.startMonth);
    setEndMonth(tempFilter?.endMonth);
    fetchData(filtersToApply,1);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };


  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    startMonth: tempFilter?.startMonth
      ? tempFilter?.startMonth.format("YYYY-MM")
      : "",
    endMonth: endMonth ? endMonth.format("YYYY-MM") : "",
    projectType: tempFilter?.projectType || [],
    vendorRegistry: tempFilter?.vendorRegistry || [],
  };

  const handleResetFilters = async () => {
    // Reset local state for date selection and selected fields
    setTempFilter({
      startDate: null,
      endDate: null,
      startMonth: null,
      endMonth: null,
      projectType: [],
      vendorRegistry: [],
    });
    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      projectType: [],
      vendorRegistry: [],
    });

    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isMonthApplied = tempFilter?.startMonth || tempFilter?.endMonth;
    const isProjectTypeApplied = tempFilter?.projectType?.length > 0;
    const isVendorApplied = tempFilter?.vendorRegistry?.length > 0;
    setIsFiltersApplied(
      isDateApplied || isMonthApplied || isProjectTypeApplied || isVendorApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      // "Month of energy export": isMonthApplied,
      "Project Type": isProjectTypeApplied,
      Vendor: isVendorApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      projectType: selectedFields.projectType,
      vendorRegistry: selectedFields.vendorRegistry,
    });
    setDrawerFilterOpen(false);
  };

  const columnHeadings = [
    { title: "Date", fieldName: "createdAt" },
    // {
    //   fieldName: "consumptionPeriod",
    //   title: "Month of energy export",
    // },
    {
      fieldName: "vendorRegistry",
      title: "Vendor",
    },
    {
      fieldName: "projectIdOrName",
      title: "Project ID/ Name",
    },
    {
      fieldName: "projectType",
      title: "Project Type",
    },
    {
      fieldName: "creditsPurchased",
      title: "No. of credits purchased (tCO₂e)",
    },
  ];

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  const onConfirm = async () => {
    try {
      const excelData = Object.values(formDataBulkUpload);
      await post(`/scope4/off-set-credit-purchase/jsonupload`, { excelData });
      setBulkUploadTable(false);
      fetchData();
      setsnackOpen({
        open: true,
        message: "Bulk upload completed successfully!",
        severity: "success",
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
          />
        );
      // case "Month of energy export":
      //   return (
      //     <MonthYearFilter
      //       startMonth={tempFilter?.startMonth}
      //       endMonth={tempFilter?.endMonth}
      //       setStartMonth={(month) =>
      //         setTempFilter((prev) => ({ ...prev, startMonth: month }))
      //       }
      //       setEndMonth={(month) => {
      //         setTempFilter((prev) => ({ ...prev, endMonth: month }));
      //       }}
      //       setErrors={setErrors}
      //       errors={errors.Month}
      //     />
      //   );
      case "Project Type":
        return (
          <MultiSelect
            title="Project Type"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  projectType: newValue.projectType || newValue,
                };
              });
            }}
            setErrors={setErrors}
            field="projectType"
            data={uniqueValues.projectType}
          />
        );
      case "Vendor":
        return (
          <MultiSelect
            title="Vendor"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  vendorRegistry: newValue.vendorRegistry || newValue,
                };
              });
            }}
            setErrors={setErrors}
            field="vendorRegistry"
            data={uniqueValues.vendorRegistry}
          />
        );
      default:
        return null;
    }
  };
  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  return (
    <MainDashboardLayout sidebar={<Scope4Layout />}>
      <Unauthorized requiredModule="Environment | Scope 4 | Carbon Offsetting | OffsetCredit">
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <Add
            id={element ? element._id : ""}
            addData={addData}
            setAddData={setAddData}
            data={element}
            title="Data"
            addUrl={`/scope4/off-set-credit-purchase/add`}
            updateUrl={`/scope4/off-set-credit-purchase/update`}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={computedInputData}
          />
          <View
            id={element ? element._id : ""}
            data={element}
            title={"Offset Credit Purchase Tracking"}
            viewData={viewData}
            setViewData={setViewData}
            inputData={computedInputData}
            handleEdit={handleEdit}
          />
          <Cards
            data={bannerData}
            title={"Carbon Offsetting"}
            onFilterChange={handlePeriodChange}
            {...{
              setSelectedMonth,
              setSelectedYear,
              selectedMonth,
              selectedYear,
            }}
          />
          {deleteDialog && (
            <DeleteAlertDialog
              fetchData={updatePage}
              {...{
                deleteDialog,
                setDeleteDialog,
                id: element._id,
                method:"delete",
                url: `${api}/scope4/off-set-credit-purchase/delte`,
                setsnackOpen,
                fetchData,
                fetchCardData,
              }}
            />
          )}
          {/* Filter Drawer */}
          {/* <Toolbar sx={{ padding: "0 16px", marginBottom: "20px" }}> */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}{" "}
          {/* Top Box for Heading, Filter Button, Add Data Button */}
          <TopMenuUpload
            setData={setElement}
            setAddData={setAddData}
            {...{
              // heading: "Coal",
              // setBulkUploadModal,
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          {/* </Toolbar> */}
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ maxWidth: "100%", marginBottom: "1rem" }}
          >
            <Box>
              <TableHeading heading={"Offset Credit Purchase Tracking"} />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: columnWidth,
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) => (
                  <ColumnHeadings
                    key={el}
                    {...{
                      title: el.title,
                      key: el.title,
                      handleSort,
                      field: el.fieldName,
                      sortConfig,
                    }}
                  />
                ))}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: columnWidth,
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) => (
                      <TableContent
                        key={el.fieldName}
                        {...{
                          fieldData:
                            el.fieldName === "consumptionPeriod"
                              ? getMonthName(item[el.fieldName]?.month) +
                                " " +
                                item[el.fieldName]?.year
                              : el?.fieldName === "projectLocation"
                              ? item?.projectLocation?.city +
                                ", " +
                                item?.projectLocation?.state +
                                ", " +
                                item?.projectLocation?.country
                              : el.fieldName === "quantityConsumed"
                              ? truncateNumber(item[el.fieldName].value) +
                                " " +
                                item[el.fieldName].unit
                              : typeof item[el.fieldName] === "object" &&
                                item[el.fieldName] !== null &&
                                item[el.fieldName].industryProcess
                              ? item[el.fieldName].industryProcess
                              : typeof item[el.fieldName] === "object" &&
                                item[el.fieldName] !== null &&
                                item[el.fieldName].name
                              ? item[el.fieldName].name
                              : item[el.fieldName],
                          dateField: el.fieldName === "createdAt" ? item.createdAt : false,
                        }}
                      />
                    ))}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent}
              {...{ totalPages, page, handleChangePage }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>

        {bulkUploadModal && (
          <BulkUploadModal
            onCloseBulkUpload={handleCloseBulkUpload}
            isBulkUploadModal={bulkUploadModal}
            setsnackOpen={setsnackOpen}
            excelData={excelData}
            setFormDataBulkUpload={setFormDataBulkUpload}
            formDataBulkUpload={formDataBulkUpload}
            setMatchData={setMatchData}
            errorClose={uploadErrorClose}
            setBulkUploadTable={setBulkUploadTable}
            setBulkUploadModal={setBulkUploadModal}
            matchedKey={"statusList"}
            fileName={"Offset"}
            url={"/scope4/off-set-credit-purchase/bulkupload"}
          />
        )}
        {bulkUploadTable && (
          <FugitiveBulkUpload
          matchData={matchData}
          setMatchData={setMatchData}
          onClose={() => setBulkUploadTable(false)}
          bulkUploadTable={bulkUploadTable}
          setFormData={setFormDataBulkUpload}
          formData={formDataBulkUpload}
          {...{ formDataBulkUpload, setFormDataBulkUpload }}
          title1="Applied to which scope(s) / emission source(s)"
          keyValue1="appliedScopes"
          matched1="matchedAppliedScopes"
          options1={ options}
          submitUrl={`scope4/off-set-credit-purchase/jsonUpload`}
          onConfirm={onConfirm}
        />
        )}
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Offset;
